export default __webpack_public_path__ + "static/media/next-earbuddyz.f8c54ab6.jpg";